import HttpClient from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';

/**
 * Event Property Definitions
 */

export const GET_EVENT_TRIGGERS_EVENT_PROPERTIES = registerQuery({
  fieldName: 'flowDoctor_eventTriggersEventProperties',
  args: ['eventFQNOrObjectTypeId'],
  fetcher: ({
    eventFQNOrObjectTypeId
  }) => {
    return HttpClient.get(`framework-builder/v1/read/metadata/property/${eventFQNOrObjectTypeId}/automationEventTriggers`).then(mapEnrollmentTriggersEventProperties);
  }
});
function mapValueToStringOrUndefined(value) {
  if (value === undefined || typeof value === 'string') {
    return value;
  }
  return String(value);
}
function mapEnrollmentTriggersEventProperties(response) {
  const eventPropertiesRecord = Object.keys(response).reduce((acc, key) => Object.assign({}, acc, {
    [key]: Object.keys(response[key].metadata).reduce((innerAcc, metadataKey) => Object.assign({}, innerAcc, {
      [metadataKey]: mapValueToStringOrUndefined(response[key].metadata[metadataKey].value)
    }), {})
  }), {});
  return eventPropertiesRecord;
}